import * as Yup from 'yup';

const INITIAL_VALUES = {
    groupName: '',
    seller: ''
};

const VALIDATION_SCHEMA = Yup.object().shape({
    groupName: Yup.string().trim().required('Group Name is required.'),
    seller: Yup.string().required('Seller is required.'),
});

export { INITIAL_VALUES, VALIDATION_SCHEMA };
